import * as React from 'react'

export function useIsScrollable(ref: React.RefObject<HTMLElement | null>) {
  const [isScrollable, setIsScrollable] = React.useState(false)

  React.useEffect(() => {
    const element = ref.current
    if (!element) return

    const checkScrollable = () => {
      setIsScrollable(element.scrollWidth > element.clientWidth)
    }

    checkScrollable()

    const resizeObserver = new ResizeObserver(checkScrollable)
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
    }
  }, [ref])

  return isScrollable
}
